import { DocumentSearchFilter } from 'src/modules/documentArchive/models/documentSearchFilter';
import { DocumentResponse } from 'src/modules/documentArchive/models/documentResponse';
import { DocumentRequest } from 'src/modules/documentArchive/models/documentRequest';
import AxiosInstance from './axios/interceptor';
import { PagedResult } from '../models/pagedResult';

const controller = 'Document';

export const getAllDocuments = (searchFilter: DocumentSearchFilter) => {
  return AxiosInstance.get<PagedResult<DocumentResponse>>(`${controller}`, { params: searchFilter });
};

export const getDocumentById = (id: number) => {
  return AxiosInstance.get<DocumentResponse>(`${controller}/${id}`);
};

export const createDocument = (data: DocumentRequest) => {
  return AxiosInstance.post<DocumentRequest>(`${controller}`, data);
};

export const updateDocument = (data: DocumentRequest) => {
  return AxiosInstance.put<DocumentRequest>(`${controller}`, data);
};

export const deleteDocument = (id: number) => {
  return AxiosInstance.delete(`${controller}/${id}`);
};

export const deleteDocuments = (ids: number[]) => {
  return AxiosInstance.delete(`${controller}/DeleteByIds`, {
    data: { ids },
  });
};

export const downloadDocumentFileById = (documentId: number) => {
  const endpoint = `${controller}/${documentId}/Data`;
  return AxiosInstance.get(endpoint, {
    responseType: 'blob',
  });
};
